interface CartEntries {
  readonly edges: ReadonlyArray<
    | ({
      readonly node:
        | ({
            readonly id: string;
            readonly productId: string | null;
            readonly product:
              | ({
                  readonly id: string;
                  readonly productId: string | null;
                })
              | null;
            readonly quantity: number | null;
          })
        | null;
    })
    | null
  > | null;
}

function findProductCartQty(
  productIdToFind: string,
  cartEntries?: CartEntries | null,
): number {
  if (!cartEntries || !cartEntries.edges) return 0;
  const cartEntry = cartEntries.edges.find(cartEntryEdge => {
    if (!cartEntryEdge || !cartEntryEdge.node || !cartEntryEdge.node) {
      return false;
    }
    const { node: { productId } } = cartEntryEdge;
    return productId === productIdToFind;
  });
  if (!cartEntry || !cartEntry.node) return 0;
  return cartEntry.node.quantity || 0; // TODO(gemma): Not sure if this is a bad fallback, so we can see if quantity is ever undefined?
}

export function productCartQtyChanged(
  productId: string,
  cartEntries: CartEntries,
  nextCartEntries: CartEntries,
) {
  const cartQty = findProductCartQty(productId, cartEntries);
  const nextCartQty = findProductCartQty(productId, nextCartEntries);
  return cartQty !== nextCartQty;
}

export default findProductCartQty;
